import React from "react";
import { AxiosResponse } from "axios";
import { connect } from "react-redux";

import TIMES from "app/consts/TIMES";
import {
  IRecordRequest,
  IMasterRecord,
  IMaster,
  IService
} from "app/api/types";

import Record from "./components/Record";
import Loader from "app/components/Loader";

import "./styles.scss";

interface IProps {
  master: IMasterRecord;
  masterList?: IMaster[];
  date: string;
  isLoading: boolean;
  serviceList: IService[];
  getRecords: (date: IRecordRequest["date"]) => Promise<AxiosResponse>;
  addRecord: (data: IRecordRequest) => Promise<AxiosResponse>;
  delRecord: (id: number) => Promise<AxiosResponse>;
  editRecord: (data: IRecordRequest) => Promise<AxiosResponse>;
}

interface IState {
  modalIsOpen: boolean;
  isSuccessActive: boolean;
  isSubmit: boolean;
  error: string;
}

class RecordList extends React.Component<IProps, IState> {
  state = {
    modalIsOpen: false,
    isSuccessActive: false,
    isSubmit: false,
    error: ""
  };

  openModal = () => {
    this.setState({ modalIsOpen: true });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  addRecord = (data: IRecordRequest) => {
    // this.props.addRecord(data).then(() => this.props.getRecords());
    this.setState({ isSubmit: false, isSuccessActive: false });
    this.closeModal();
  };

  editRecord = (data: IRecordRequest) => {
    this.props
      .editRecord(data)
      .then(() => {
        this.setState({ error: "" });
        this.props.getRecords(this.props.date);
      })
      .catch(err => this.setState({ error: err[0].msg }));
  };

  delRecord = (id: number) => {
    this.props.delRecord(id).then(() => this.props.getRecords(this.props.date));
  };

  takeFullDay = () => {
    const data = {
      masterId: this.props.master.masterid,
      timeStart: TIMES[0],
      timeEnd: TIMES[TIMES.length - 1],
      serviceIds: [],
      date: this.props.date,
      customerName: "занят весь день",
      customerPhone: " ",
      isAccepted: true
    };

    this.props
      .addRecord(data)
      .then(() => this.props.getRecords(this.props.date));
  };

  onSuccessChange = (active: boolean) => {
    this.setState({ isSuccessActive: active });
  };

  recordsList = () => {
    const recordAmount = this.props.master.records.filter(el => el !== null)
      .length;

    if (recordAmount === 0) return <p>Записей нет</p>;

    return this.props.master.records.map(
      record =>
        record && (
          <Record
            serviceList={this.props.serviceList}
            masterList={this.props.masterList || []} //я в рот ебал почему родительский компонент не понимает что мастерлист приходит из редакса
            record={record}
            onSubmit={this.editRecord}
            onDelete={this.delRecord}
            key={record.id}
          />
        )
    );
  };

  render() {
    const recordAmount = this.props.master.records.filter(el => el !== null)
      .length;

    if (this.props.isLoading)
      return (
        <div className="loader-wrapper">
          <Loader />
        </div>
      );

    return (
      <div className="user-group">
        <div className="records-user-group__header">
          <div
            className="records__avatar"
            style={{
              background: `url(${process.env.REACT_APP_API_HOST}/static/masters/${this.props.master.masterid}/main.jpg) no-repeat`,
              height: "80px",
              width: "80px",
              borderRadius: "50%",
              backgroundSize: "cover"
            }}
          ></div>

          <p className="records-label__text">{this.props.master.name}</p>
          <p className="">{this.props.master.position}</p>

          <div className="records-header__group-label">
            <p className="label__counter">записей: {recordAmount}</p>

            {/* <button className="label__add-button" onClick={this.openModal} /> */}
          </div>

          {recordAmount === 0 && (
            <button className="full-day" onClick={this.takeFullDay}>
              занять весь день мастера
            </button>
          )}
          <p className="label__error">{this.state.error}</p>
        </div>

        <div className="user-group__content">
          <div className="column">{this.recordsList()}</div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    masterList: state.masters.masterList
  };
};

export default connect(mapStateToProps, null)(RecordList);
